import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import trans from 'counterpart'
import { updateEntity } from '../actions/entityActions'
import { withActiveLink } from '../contexts/NavContext'
import { isMobile } from '../utilities/deviceUtilities'
import { getUserAgent } from '../selectors/environmentSelectors'
import Link from './typography/Link'

class NavLinkBlock extends Component {
  componentDidMount = () => {
    if (this.props.location.pathname.indexOf(this.props.value) > -1) {
      this.props.setActiveLink(this.props.block.id)
    }
  }

  handleMouseEnter = () => {
    if (!this.props.isMobile) {
      this.props.setActiveLink(this.props.block.id)
    }
  }

  toggleSubMenu = () => {
    const { isMobile, activeLink, block } = this.props
    if (isMobile) {
      if (block.id === activeLink) {
        this.props.setActiveLink(null)
      } else {
        this.props.setActiveLink(block.id)
      }
    }
  }

  // handleClick = () => {
  //   document.getElementsByTagName('html')[0].className = '';
  //   document.body.className = '';

  //   this.props.closeNavbar();
  // }

  isLinkActived = (item) => {
    const { entities, location } = this.props
    return entities[item].value === location.pathname.substr(1, location.pathname.length)
  }

  render = () => {
    const { activeLink, block, entities, mobileMenuIsOpen } = this.props

    return (
      <li
        className={`nav-item ${block.id === activeLink ? 'activated' : ''} ${block.children.length > 0 ? 'dropdown' : ''} ${block.children.length === 0 ? 'no-dropdown' : ''} `}
        onMouseEnter={this.handleMouseEnter}
        onClick={this.toggleSubMenu}
      >
        <div role='button' onClick={this.toggleSubMenu}>
          {mobileMenuIsOpen && block.id !== activeLink && (
            <div className='nav-link nav-mobile'>
              {block.display_name ? block.display_name : block.name}
            </div>
          )}
          {(!mobileMenuIsOpen || (mobileMenuIsOpen && block.id === activeLink)) && (
            <Link className='nav-link nav-mobile' to={block.value}>
              {block.display_name ? block.display_name : block.name}
            </Link>
          )}
        </div>
        {block.children.length > 0 && (
          <>
            <button
              className='navbar-toggler'
              type='button'
            />
            <div className='dropdown-menu'>
              <div className='container'>
                {block.children.map(item => (
                  <Link className={`dropdown-item ${this.isLinkActived(item) ? 'activated' : ''}`} key={item} to={entities[item].value}>
                    {entities[item].display_name ? entities[item].display_name : entities[item].name}
                  </Link>
                ))}
              </div>
            </div>
          </>
        )}
      </li>
    )
  }
}

NavLinkBlock.propTypes = {
  activeLink: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  block: PropTypes.object.isRequired,
  // closeNavbar: PropTypes.func,
  mobileMenuIsOpen: PropTypes.bool,
  entities: PropTypes.object,
  isMobile: PropTypes.bool.isRequired,
  location: PropTypes.object,
  setActiveLink: PropTypes.func.isRequired,
  value: PropTypes.string
}

const mapState = state => ({
  // TODO: Do not pass the complete block array here, since this will cause unneccesary overhead.
  entities: state.entities.blocks,
  isMobile: isMobile(getUserAgent(state))
})

const mapDispatch = (dispatch, ownProps) => ({
  closeNavbar: () => dispatch(updateEntity('blocks', ownProps.parentId, 'selected', false))
})

export default connect(
  mapState,
  mapDispatch
)(withRouter(withActiveLink(NavLinkBlock)))
